// NPM Import
import React, { Fragment, Component } from "react";
import Select, { components } from "react-select";

// Component Imports
import { UpgradePopUp, UpgradeBadge } from "../../../commonComponents";

const { Option } = components;
const UpgradeOption = props => (
  <Option {...props}>
    {props.data.label}
    {props.data.label === "Bundle" && <UpgradeBadge />}
  </Option>
);

export default class ProductConfigurationSelectUpgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionData: this.convertIntoKeyValue(props.optionData),
      showPopUp: false,
    };
  }

  convertIntoKeyValue = options => {
    const data = [];
    options.forEach(element => {
      data.push({
        value: element,
        label: element,
      });
    });
    return data;
  };

  _onSelectChange = value => {
    console.debug("_onSelectChange", value);
    if (value.label === "Bundle") {
      this.setState({
        showPopUp: true,
      });
    } else {
      this.props.onSelectChange("productConfig", value.value);
    }
  };

  togglePopUp = () => {
    this.setState({
      showPopUp: false,
    });
  };

  _getValue = productValue => {
    let data = "";
    if (Object.keys(productValue).length > 0 && productValue !== "") {
      data = { value: productValue, label: productValue };
    }
    return data;
  };

  render() {
    const { title, productValue } = this.props;
    console.debug("ProductConfigurationSelectUpgrade", this.props);
    return (
      <Fragment>
        <div className="addproduct-div-wrapper">
          <span className="addproduct-label">
            {title}
            <span className="required-input">*</span>
          </span>
          <Select
            components={{ Option: UpgradeOption }}
            options={this.state.optionData}
            onChange={value => this._onSelectChange(value)}
            value={this._getValue(productValue)}
            data-test="productconfigurationselectupgrade-select"
          />
        </div>
        {this.state.showPopUp && (
          <UpgradePopUp
            featureName={this.props.featureName}
            onClose={() => this.togglePopUp()}
          />
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Products/ProductConfiguration/ProductConfigurationSelectUpgrade.js